/* Verona Tempo r11 (A): search panel (full-width overlay, recent searches, suggestions). */
/**
 * Only when Theme settings > Verona Tempo > "Full-screen search panel (round 11)" is ticked
 * (window.vtConfig.r11search.on, from snippets/vt-cart-config.liquid; that also puts html.vt-r11-search).
 * The panel itself is Symmetry's <main-search> in sections/header.liquid (opened by main.js with body.show-search,
 * filled as she types by assets/main-search.js — not edited). This file only adds, around it:
 *  - "Suggestions": the words of the header's search recommendations menu (Theme editor > Header > search
 *    recommendations), as chips linking to those real collections; if that menu is empty, the collection links of the
 *    main menu (Heels, Sandals, Flats…). Nothing is invented. Shown with "Recent searches" (round 9) before she types.
 *  - Headings "Products" / "Collections & pages" over the live results, and "View all results (N)" (N = the number
 *    the search page shows, read from sections/main-search.liquid data-vt-results-count).
 *  - Esc closes from anywhere in the panel, Tab stays inside it while open, focus goes back to the magnifier
 *    (or whatever opened it). The screen-reader "8 products found" line (vt-theme.js) is unchanged.
 *  - A tap on a live result / "View all" counts as a recent search (same list as vt-theme.js, max 6).
 */
(function () {
  'use strict';

  /* Arabic pages: Shopify's quick search (/ar/search/suggest) answers "Unsupported buyer locale" (417), so the
     panel showed nothing while she typed and a console error came up. On Arabic pages the panel asks the normal
     search page instead (Arabic names and links; main-search.js has this way built in), and the one-line word
     suggestions under the field (search-suggestions.js, English-only there) are asked in the default language and
     hidden, so no error. Always on (a fix, not a new look). */
  var th = window.theme;
  if (th && /^ar(-|$)/i.test(document.documentElement.lang || '')) {
    if (th.Shopify && th.Shopify.features) th.Shopify.features.predictiveSearch = false;
    if (th.routes && th.routes.predictiveSearch) th.routes.predictiveSearch = String(th.routes.predictiveSearch).replace(/^\/ar(?=\/)/, '');
    document.documentElement.classList.add('vt-r11-no-ps');
  }

  var cfg = (window.vtConfig && window.vtConfig.r11search) || {};
  if (!cfg.on) return;
  var S = cfg.strings || {};
  var panel = document.querySelector('.section-header main-search');
  if (!panel || panel.vtR11) return;
  panel.vtR11 = true;

  var input = panel.querySelector('.main-search__input');
  var closeBtn = panel.querySelector('.main-search__close');
  var results = panel.querySelector('.main-search__results');
  var container = panel.querySelector('.main-search__container') || panel;
  if (!input || !results) return;

  var core = window.vtCore || {};
  var esc = core.esc || function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  panel.classList.add('vt-r11-sp');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', input.getAttribute('aria-label') || S.close || 'Search');
  if (closeBtn) {
    if (S.close) closeBtn.setAttribute('aria-label', S.close);
    if (!closeBtn.getAttribute('type')) closeBtn.setAttribute('type', 'button');
  }
  input.setAttribute('enterkeyhint', 'search');

  /* ------------------------------------------------------------------ start view: recent searches + suggestions */
  function suggestionLinks() {
    var out = [];
    var seen = {};
    function add(href, text) {
      text = String(text || '').replace(/\s+/g, ' ').trim();
      if (!href || !text || href === '#' || seen[href]) return;
      seen[href] = true;
      out.push({ href: href, text: text });
    }
    panel.querySelectorAll('.main-search__suggestions .search-recommendations__item').forEach(function (item) {
      if (item.classList.contains('search-recommendations__item--with-row')) {
        var head = item.querySelector('.search-recommendations__heading a[href]');
        if (head) add(head.getAttribute('href'), head.textContent);
        return;
      }
      var a = item.querySelector('a[href]');
      if (!a) return;
      var t = item.querySelector('.collection-block h2, .collection-block .h4, .product-block__title, .search-recommendations__link');
      add(a.getAttribute('href'), t ? t.textContent : a.textContent);
    });
    if (!out.length) {
      // fallback: the collections in the main menu, in menu order (computer menu, then phone menu)
      document.querySelectorAll('#main-nav a[href*="/collections/"], .mobile-navigation-drawer a[href*="/collections/"]').forEach(function (a) {
        if (out.length >= 8) return;
        var href = a.getAttribute('href') || '';
        if (/\/collections\/?$|\/products\//.test(href)) return;
        add(href, a.textContent);
      });
    }
    return out.slice(0, 10);
  }

  var start = document.createElement('div');
  start.className = 'vt-r11-start';
  var status = panel.querySelector('[data-vt-search-status]');
  results.insertAdjacentElement('afterend', start);
  var recent = panel.querySelector('[data-vt-rsearch]');
  if (recent) start.appendChild(recent);
  var links = suggestionLinks();
  if (links.length) {
    var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
    var box = document.createElement('div');
    box.className = 'vt-r11-sugg';
    box.innerHTML = '<p class="vt-r11-sugg__title" id="vt-r11-sugg-title">' + esc(S.suggestions || 'Suggestions') + '</p>' +
      '<ul class="vt-r11-sugg__list" role="list" aria-labelledby="vt-r11-sugg-title">' +
      links.map(function (l) {
        return '<li><a class="vt-r11-sugg__chip" href="' + esc(l.href) + '"><span>' + esc(l.text) + '</span>' + arrow + '</a></li>';
      }).join('') + '</ul>';
    start.appendChild(box);
  }
  if (status) start.insertAdjacentElement('beforebegin', status);

  /* ------------------------------------------------------------------ live results: headings + "View all results (N)" */
  var counts = {};
  function countFor(link) {
    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return; }
    var key = url.search;
    var show = function (n) {
      if (!link.isConnected) return;
      if (n > 0 && S.viewAll) link.textContent = String(S.viewAll).replace('[n]', n);
    };
    if (counts[key] !== undefined) { show(counts[key]); return; }
    url.searchParams.set('section_id', 'main-search');
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /data-vt-results-count="(\d+)"/.exec(html || '');
        if (!m) return;
        counts[key] = parseInt(m[1], 10);
        show(counts[key]);
      })
      .catch(function () {});
  }

  function dress() {
    var prods = results.querySelector('.main-search__results__products');
    if (prods && !prods.vtR11) {
      prods.vtR11 = true;
      // at most 8 cards (the search-page way can hand over 9)
      prods.querySelectorAll('.main-search-result.product-block').forEach(function (b, i) { if (i >= 8) b.remove(); });
      var h = document.createElement('h2');
      h.className = 'vt-r11-sres__title';
      h.textContent = S.products || 'Products';
      prods.insertAdjacentElement('afterbegin', h);
    }
    var pages = results.querySelector('.main-search__results__pages');
    if (pages && !pages.vtR11) {
      pages.vtR11 = true;
      var ph = pages.querySelector('.main-search-result__heading');
      if (ph && S.pages) ph.textContent = S.pages;
    }
    var all = results.querySelector('.main-search__results-all-link');
    if (all && !all.vtR11) {
      all.vtR11 = true;
      if (S.viewAllPlain) all.textContent = S.viewAllPlain;
      countFor(all);
    }
  }
  if ('MutationObserver' in window) {
    new MutationObserver(dress).observe(results, { childList: true });
  }

  /* a tap on a live result or "View all" counts as a recent search (vt-theme.js reads the same list) */
  function rememberTyped() {
    var q = String(input.value || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (q.length < 2 || !core.readList || !core.writeList) return;
    var key = (core.keys && core.keys.recentSearches) || 'vt-recent-searches';
    var lower = q.toLowerCase();
    var list = core.readList(key).filter(function (x) { return String(x).toLowerCase() !== lower; });
    list.unshift(q);
    core.writeList(key, list.slice(0, 6));
  }
  results.addEventListener('click', function (evt) {
    if (evt.target.closest && evt.target.closest('a[href]')) rememberTyped();
  });

  /* ------------------------------------------------------------------ open / close: Esc, Tab inside, focus back */
  var opener = null;
  document.addEventListener('click', function (evt) {
    if (!evt.isTrusted || !evt.target.closest) return;
    var o = evt.target.closest('.show-search-link, [data-vt-bnav-action="search"]');
    if (o) opener = o;
  }, true);

  function isOpen() { return document.body.classList.contains('show-search'); }
  function visible(el) {
    if (!el || !el.isConnected) return false;
    if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  }
  function close() {
    if (closeBtn) closeBtn.dispatchEvent(new Event('click'));
    else document.body.classList.remove('show-search');
  }
  function giveFocusBack() {
    var target = opener && visible(opener) ? opener : null;
    if (!target) {
      target = Array.prototype.filter.call(document.querySelectorAll('.section-header .show-search-link, [data-vt-bnav-action="search"]'), visible)[0] || null;
    }
    var a = document.activeElement;
    if (target && (!a || a === document.body || panel.contains(a))) {
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
    opener = null;
  }

  var wasOpen = isOpen();
  new MutationObserver(function () {
    var now = isOpen();
    if (now === wasOpen) return;
    wasOpen = now;
    if (now) {
      panel.scrollTop = 0;
      // Symmetry focuses the field after 500 ms; do it at once (the panel is visible straight away)
      window.setTimeout(function () { if (isOpen() && document.activeElement !== input) input.focus({ preventScroll: true }); }, 30);
    } else {
      giveFocusBack();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', function (evt) {
    if (!isOpen()) return;
    if (evt.key === 'Escape' || evt.key === 'Esc') {
      evt.preventDefault();
      close();
      return;
    }
    if (evt.key !== 'Tab') return;
    var list = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), visible);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var a = document.activeElement;
    if (!panel.contains(a)) { evt.preventDefault(); first.focus(); return; }
    if (evt.shiftKey && a === first) { evt.preventDefault(); last.focus(); }
    else if (!evt.shiftKey && a === last) { evt.preventDefault(); first.focus(); }
  });
})();
